import * as React from 'react';
import Box from '@mui/material/Box';

import CustomDataGrid from '../../../Components/CustomDataGrid/CustomDataGrid';
import axios from 'axios';
import { genURL } from '../../../_getjson';

import DraggableDialog from '../../../Components/CustomDialogs/DraggableDialog';
import JobDetail from './jobDetail';
import moment from 'moment-timezone';

import Splittext from '../../../CustomFunction/Splittext/Splittext';

import CustomDateRangePicker from '../../../Components/CustomDatepicker/CustomDateRangePicker';
import { Button } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import CustomBackdrop from '../../../Components/CustomBackdrop/Barckdrop';
import { da } from 'date-fns/locale';
import CustomInput from '../../../Components/CustomInput/CustomInput';

const d = new Date();

export default function ListData() {
    const [state, setState] = React.useState({
        rowData: [],
        useData: [],
        dataSelect: [],
        detailJob: [],
        openDialog: false,
        titleDialog: "รายละเอียด",
        NIDSData: [],
        DateRangeDefaultValue: {
            dateStart: moment(d).format("YYYYMMDD"),
            dateEnd: moment(d).format("YYYYMMDD")
        },
        openBackdrop: false,
        dateStart: moment(d).format("YYYYMMDD"),
        dateEnd: moment(d).format("YYYYMMDD"),
        nidsLoading: false,
        csLoading: false,
        rowNumber: 100

    })
    React.useEffect(async () => {

        return () => {
        }
    }, [])


    const handleSaveData = () => {
        //console.log(state.dataSelect);
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 35 },
        {
            field: 'DOCNO',
            headerName: 'DOCNO',
            width: 30,
            editable: false,
            flex: 1
        },
        {
            field: 'NAME',
            headerName: 'ARNAEM',
            width: 200,
            editable: false,
            flex: 1
        },
        {
            field: 'JOBOPERATION',
            headerName: 'JOBOPERATION',
            width: 100,
            editable: false,
            flex: 1
        },
        {
            field: 'MILAGE',
            headerName: 'MILAGE',
            width: 50,
            editable: false,
            flex: 1
        }, {
            field: 'MOBILE_NO',
            headerName: 'MOBILE_NO',
            width: 200,
            editable: false,
            flex: 1
        }, {
            field: 'VIN_NO',
            headerName: 'VIN_NO',
            width: 200,
            editable: false,
            flex: 1
        },
    ];

    const loadData = async () => {
        await setState({ ...state, csLoading: true })
        let url = "selectdatafornids/getJob?top=" + state.rowNumber + "&user=" + localStorage.getItem('Username') + "&startdate=" + state.dateStart + "&stopdate=" + state.dateEnd
        let resData = await axios.get(genURL(url)).then(res => {
            return res.data
        })
        await setState({
            ...state,
            useData: resData,
            closeDialog: false
        })
        // console.log("data resData", resData)
        // console.log("NIDSData ", state.NIDSData)
    }
    const fetchData = async () => {
        setState({ ...state, nidsLoading: true, openBackdrop: true })
        try {
            const urls = [
                'http://localhost:5000/corspoxy?url=https://nidsapi.thaihonda.co.th/WC_API/SVJobHeader/41606/000/' + state.dateStart + '/' + state.dateEnd,
                'http://localhost:5000/corspoxy?url=https://nidsapi.thaihonda.co.th/WC_API/SVJobHeader/41606/001/' + state.dateStart + '/' + state.dateEnd,
                'http://localhost:5000/corspoxy?url=https://nidsapi.thaihonda.co.th/WC_API/SVJobHeader/41606/002/' + state.dateStart + '/' + state.dateEnd,
                'http://localhost:5000/corspoxy?url=https://nidsapi.thaihonda.co.th/WC_API/SVJobHeader/41606/003/' + state.dateStart + '/' + state.dateEnd,
                'http://localhost:5000/corspoxy?url=https://nidsapi.thaihonda.co.th/WC_API/SVJobHeader/41606/004/' + state.dateStart + '/' + state.dateEnd
            ];

            const responses = await Promise.all(urls.map(url => axios.get(url)));
            const combinedData = responses.flatMap(response => {
                if (response.data && Array.isArray(response.data)) {
                    return response.data;
                } else {
                    console.error('Invalid response data:', response.data);
                    return [];
                }
            });
            console.log('combinedData:', combinedData);

            await setState(prevState => ({
                ...prevState,
                NIDSData: combinedData.data,
                nidsLoading: false,
                openBackdrop: false
            }))
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const dataInTable = (val) => {
        console.log("dataInTable", val)
    }
    const selcetRow = (val) => {
        console.log("selcetRow", val)
    }
    // after select data
    const Dataselect = async (val) => {
        //   await console.log("Dataselect", val)
        let newVal = await state.useData.filter((item) => {
            // console.log(valItem.DOCNO)
            return val.some((valItem) => {
                return item.DOCNO === valItem.DOCNO
            })
        })
        await setState({ ...state, dataSelect: newVal })
    }
    // React.useEffect(() => {
    //     createParams(state.dataSelect)
    //     return () => {
    //     }
    // }, [state.dataSelect])
    const createParams = async (val) => {
        console.log("data NISDData", state.NIDSData)
        console.log("data", val)
        const newVal = []
        val.map((item) => {
            let dateData = new Date(item.START_DATE).toLocaleTimeString("th-TH", { timeZone: "UTC" })
            let timeDataStar = Splittext(dateData, ":")
            let fDate = moment.utc(item.START_DATE).add(30, 'minute').toISOString().valueOf()
            let fDataT = Splittext(fDate, "T")
            let timeDataEnd = Splittext(fDataT[1], ":")
            let partsAmount = 0
            let serviceAmount = 0
            if (item.JOB_DETAILS.length > 0) {
                for (let index = 0; index < item.JOB_DETAILS.length; index++) {
                    // เช็คแรพเภทสินค้า 02 คืออะไหล่ 
                    if (item.JOB_DETAILS[index].ITEM_TYPE_CODE === "02") {
                        partsAmount = partsAmount + Number(item.JOB_DETAILS[index].AMOUNT)
                    }
                    // ค่าบริการ
                    if (item.JOB_DETAILS[index].ITEM_TYPE_CODE === "03") {
                        serviceAmount = serviceAmount + Number(item.JOB_DETAILS[index].AMOUNT)
                    }
                }
            }
            //เช็คสตริง
            let jobCategory = "", jobOperation = ""
            if (item.JOB_OPERATION_CODE !== "Y115") {
                jobCategory = 'บำรุงรักษาตามระยะ (P.M.)'
                jobOperation = item.JOB_OPERATION
            } else {
                jobCategory = 'ซ่อมทั่วไป (G.R.)'

                if (!item.PROJECT === "") {
                    jobOperation = 'ซ่อมแคมเปญ'
                } else {
                    jobOperation = 'ซ่อมทั่วไป'
                }
            }
            let jobDetail = item.JOB_DETAILS.filter(function (itemJobDetail) {
                return itemJobDetail.ITEM_TYPE_CODE !== "03"
            })
            console.log("jobDetail", jobDetail)
            newVal.push({
                "VIN_NO": item.VIN_NO,
                "JOB_NO": "64SERV/0000616",
                "JOB_DATE": moment(item.START_DATE).format("YYYYDDMM"),
                "ID_CARD": item.ID_CARD,
                "FIRST_NAME": item.FIRST_NAME,
                "LAST_NAME": item.LAST_NAME,
                "E_MAIL": item.E_MAIL,
                "MOBILE_NO": item.MOBILE_NO,
                "MILAGE": item.MILAGE,
                "START_DATE": moment(item.START_DATE).format("YYYYDDMM"),
                "START_TIME": timeDataStar[0] + timeDataStar[1],
                "FINISHED_DATE": moment(item.START_DATE).format("YYYYDDMM"),
                "FINISHED_TIME": timeDataEnd[0] + timeDataEnd[1],
                "STATUS": "90",
                "PARTS_AMT": partsAmount,
                "SERVICE_AMT": serviceAmount,
                "JOB_CATEGORY": jobCategory,
                "JOB_OPERATION": jobOperation,
                "JOB_DETAILS": jobDetail
            })
        })
        console.log("newVal", newVal)
    }
    //end after select data
    const rowDoubleClick = async (val) => {

        let x = await state.useData.filter((item) => {
            return item.DOCNO === val.row.DOCNO
        }
        )
        await setState({
            ...state,
            detailJob: x,
            titleDialog: "รายละเอียดเลขที่เอกสาร:" + x[0].DOCNO,
            openDialog: true
        })
    }
    // custom element to DataGrid
    const resInput = (source, val) => {
        console.log("resInput", source, val);
        setState({
            ...state, dateStart: moment(val.dateStart).format("YYYYMMDD"),
            dateEnd: moment(val.dateEnd).format("YYYYMMDD")
        })
    }
    const handleSearchData = async () => {
        await loadData()
        await fetchData()
    }

    React.useEffect(async () => {
        try {
            if (state.nidsLoading === false &&
                state.nidsLoading === false) {
                console.log('useEffect NIDSData:', state.NIDSData, 'useEffect useData:', state.useData);
                const notEqualItems = await compareData(state.NIDSData, state.useData);
                await createTable(notEqualItems);
            }
        } catch (error) {
            console.error('Error comparing data:', error);
        }
    }, [state.nidsLoading, state.csLoading])
    const createTable = async (data) => {
        console.log("data", data);
        let rowData = []
        for (let index = 0; index < data.length; index++) {
            rowData.push({
                id: index + 1,
                DOCNO: data[index].DOCNO,
                NAME: data[index].FIRST_NAME + "  " + data[index].LAST_NAME,
                JOBOPERATION: data[index].JOB_OPERATION,
                MILAGE: data[index].MILAGE,
                MOBILE_NO: data[index].MOBILE_NO,
                VIN_NO: data[index].VIN_NO,
                fontColor: ""
            })
        }
        console.log("rowData", rowData)
        await setState({ ...state, rowData: rowData })
    }
    const compareData = (dataMain1, dataMain2) => {
        try {
            return dataMain2.filter(data2 =>
                !dataMain1.some(data1 => data1.FRAME_NO === data2.VIN_NO)
            );
        }
        catch (error) {
            console.error('Error comparing data:', error);
            return dataMain2;
        }
    };
    return (
        <Box >
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} md={2} lg={2} xl={2} sm={12}>
                    <CustomInput inputType={'number'} id={'rowSelect'} label={`จำนวนรายการ`} placeholder={"ถ้าต้องการรายการทั้งหมดตามเงื่อนไขให้กรอก -1 ค่าเริ่มต้นเป็น 100"} resData={(e => setState({ ...state, rowNumber: e }))} />
                </Grid>
                <Grid item xs={12} md={8} lg={8} xl={8} sm={12}>
                    <CustomDateRangePicker label={"วันที่"} label2="ถึง" resData={e => resInput("Date", e)}
                        defaultValue={state.DateRangeDefaultValue} />
                </Grid>
                <Grid item xs={12} md={2} lg={2} xl={2} sm={12}>
                    <Button onClick={handleSearchData} variant='contained'>ค้นหา</Button>
                </Grid>

            </Grid>

            {state.rowData.length > 0 ?
                <CustomDataGrid
                    //defaultDataintable={state.rowData}
                    datacolumns={columns}
                    datarows={state.rowData}
                    rowHeight={38}
                    startRow={10}
                    Dataintable={e => dataInTable()}
                    option={[{ add: false, del: false, select: true }]}
                    checkboxSelection
                    onRowClick={e => selcetRow([e.row])}
                    Dataselect={e => Dataselect(e)}
                    onRowDoubleClick={e => rowDoubleClick(e)}
                    disableSelectionOnClick
                />
                : null
            }
            <DraggableDialog open={state.openDialog} title={state.titleDialog} closeDialog={e => setState({ ...state, openDialog: e })} >
                <JobDetail data={state.detailJob} closeDialog={e => setState({ ...state, openDialog: e })} />
            </DraggableDialog>
            <CustomBackdrop open={state.openBackdrop} />
        </Box >
    );
}